module.exports = __webpack_public_path__ + "static/img/banner-mobile0.e68666f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-mobile0.jpg
// module id = sdJj
// module chunks = 1